"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobAutomation = void 0;
const typeorm_1 = require("typeorm/browser");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const contact_profile_enum_1 = require("./contact-profile-enum");
const job_type_enum_1 = require("./job-type-enum");
const opportunity_1 = require("./opportunity");
let JobAutomation = class JobAutomation {
};
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
        name: 'id',
    }),
    __metadata("design:type", Number)
], JobAutomation.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.ManyToOne)((type) => opportunity_1.Opportunity, (opportunity) => opportunity.jobAutomation),
    __metadata("design:type", opportunity_1.Opportunity)
], JobAutomation.prototype, "opportunity", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    data_ui_1.DataUi.Override({ label: 'Job Type' }),
    data_ui_1.DataUi.EnumValues(job_type_enum_1.JobTypeEnum),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: job_type_enum_1.JobTypeEnum,
        nullable: false,
    }),
    __metadata("design:type", String)
], JobAutomation.prototype, "jobType", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Enable Automatic Job Creation & Quote Sending' }),
    (0, typeorm_1.Column)('boolean', {
        name: 'auto_create_job',
        default: false,
    }),
    __metadata("design:type", Boolean)
], JobAutomation.prototype, "autoCreateJob", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Minimum Job Product Count' }),
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAutomation.prototype, "minProductCount", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Maximum Job Product Count' }),
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAutomation.prototype, "maxProductCount", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Minimum Job Service Count' }),
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAutomation.prototype, "minServiceCount", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Maximum Job Service Count' }),
    (0, typeorm_1.Column)('double precision', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAutomation.prototype, "maxServiceCount", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Minimum Selling Price' }),
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAutomation.prototype, "minSellingPrice", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Maximum Selling Price' }),
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAutomation.prototype, "maxSellingPrice", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Minimum Listing Price' }),
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAutomation.prototype, "minListPrice", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Maximum Listing Price' }),
    (0, typeorm_1.Column)('decimal', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobAutomation.prototype, "maxListPrice", void 0);
__decorate([
    data_ui_1.DataUi.Override({ isFilter: false }),
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], JobAutomation.prototype, "createdAt", void 0);
__decorate([
    data_ui_1.DataUi.Override({ isFilter: false }),
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], JobAutomation.prototype, "updatedAt", void 0);
JobAutomation = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Job Automation',
        nameProperties: ['jobType', 'opportunity.name'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Unique)(['opportunity', 'jobType']),
    (0, typeorm_1.Entity)('job_automation', { schema: 'public' })
], JobAutomation);
exports.JobAutomation = JobAutomation;
//# sourceMappingURL=job-automation.js.map